import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
import { Check } from 'lucide-react';
export function InvestmentSection() {
  const features = ['3 Fases completas del sistema', '5 Bonos exclusivos incluidos', 'Acceso inmediato y de por vida', 'Uso ilimitado en cualquier dispositivo'];
  return <SectionWrapper className="!py-8 md:!py-12" data-id="element-95">
      <div className="max-w-2xl mx-auto text-center" data-id="element-96">
        {/* Real value label */}
        <p className="text-sm font-medium tracking-wide uppercase text-text-secondary mb-2" data-id="element-97">
          Valor real del sistema
        </p>
        <p className="text-3xl md:text-4xl font-serif text-text-secondary/60 line-through mb-8" data-id="element-98">
          $70.000
        </p>

        {/* Launch price */}
        <span className="inline-block px-4 py-1 border border-plum/20 text-plum text-sm font-medium tracking-wide mb-4" data-id="element-99">
          VALOR ESPECIAL DE LANZAMIENTO
        </span>

        <div className="mb-3" data-id="element-100">
          <span className="text-6xl md:text-7xl font-serif font-bold text-text" data-id="element-101">
            $19.990
          </span>
          <span className="text-text-secondary text-xl ml-2" data-id="element-102">ARS</span>
        </div>

        <p className="text-lg text-plum font-medium mb-6" data-id="element-103">
          Ahorrás más de $50.000 hoy.
        </p>

        <ul className="text-left max-w-sm mx-auto space-y-3 mb-8" data-id="element-104">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-105">
              <Check className="w-5 h-5 text-sage mr-3 flex-shrink-0 mt-0.5" data-id="element-106" />
              <span className="text-text-secondary" data-id="element-107">{feature}</span>
            </li>)}
        </ul>

        <CTAButton className="w-full md:w-auto min-w-[280px]" data-id="element-108">
          Quiero recuperar mi eje
        </CTAButton>

        <p className="mt-4 text-xs text-text-secondary/60" data-id="element-109">
          Pago único. Acceso seguro. Garantía de satisfacción.
        </p>
      </div>
    </SectionWrapper>;
}